import React, {useEffect, useMemo,useState} from "react";
import {
  Select,
  MenuItem,
  IconButton,
  makeStyles,
  FormControl
} from "@material-ui/core";
import clsx from "clsx";
import { MenuPropsForTableFilter } from "../../helpers/menuProps";
import { NoDataText, DefaultMenuItem } from "../commons/StyledTexts";
import { CloseOutlined } from "@material-ui/icons";

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: theme.spacing(2),
    // height: 35,
    padding: "7.5px 50px 7.5px 14px",
    verticalAlign: "middle",

    "&:hover .single-select-close": {
      visibility: "visible"
    }
  },
  noEmpty: {
    padding: 0,
    minWidth: 80,

    "& .default-value": {
      position: "absolute",
      left: 10,
      top: "50%",
      transform: "translateY(-50%)"
    }
  },
  small: {
    "& .MuiOutlinedInput-input": {
      paddingTop: 9.5,
      paddingBottom: 9.5,
      paddingRight: 50
    }
  },
  select: {
    position: "absolute",
    left: 0,
    top: 0
  },
  close: {
    position: "absolute",
    // right: 7,
    // top: -3,
    right: 26,
    top: "50%",
    transform: "translateY(-50%)",
    color: theme.palette.text.secondary,
    fontSize: 16,
    cursor: "pointer",
    visibility: "hidden",
    zIndex: 10,

    "&:hover": {
      color: "#444"
    }
  }
}));

const SingleSelector = props => {
  const {
    name,
    options = [],
    initialValue,
    value = "",
    defaultValue = "",
    placeholder,
    onChange,
    disabled,
    readOnly,
    noDropdown,
    noOptionsText,
    clearable = true,
    variant = "outlined",
    size = "small",
    className,
    style
  } = props;

  const classes = useStyles();

  const [ showDefaultText, setShowDefaultText] = useState(true)

  useEffect(()=>{
    if (value === undefined || value === null) {
      setShowDefaultText(true)
      return
    }

    setShowDefaultText(!options.find(option => option.id === value))
  },[options,value])

  // const showDefaultText = () => {
  //   if (value === undefined || value === null) return true;
  //   return !options.find(option => option.id === value);
  // };

  return (
    <FormControl
      className={clsx(
        classes.root,
        size === "small" && classes.small,
        !showDefaultText && classes.noEmpty,
        className
      )}
      style={style}
    >
      <DefaultMenuItem text={placeholder} ifShow={showDefaultText} />
      {clearable && !disabled && !readOnly && !showDefaultText && (
        // <IconButton
        //   className={classes.close}
        //   onClick={() => onChange({ target: { name, value: initialValue } })}
        // >
        <CloseOutlined
          fontSize="small"
          color="inherit"
          className={clsx("single-select-close", classes.close)}
          onClick={() => onChange({ target: { name, value: initialValue } })}
        />
        // </IconButton>
      )}
      <Select
        className={showDefaultText ? classes.select : ""}
        name={name}
        variant={variant}
        value={value !== undefined ? value : defaultValue}
        disabled={disabled}
        readOnly={readOnly || noDropdown}
        fullWidth
        MenuProps={MenuPropsForTableFilter}
        displayEmpty
        onChange={onChange}
      >
        {options.length > 0 ? (
          options.map(o => (
            <MenuItem key={o.id} value={o.id} name={o.name}>
              {o.name}
            </MenuItem>
          ))
        ) : (
          <MenuItem value={false} disabled>
            <NoDataText text={noOptionsText} />
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default SingleSelector;
